export default function localDate(date) {
  return new Date(date).toLocaleDateString()
}
